import { Payment, Order, Invoice, Reversal, SplitOutpayment } from '@/classes/models'

export default class PaymentJob {
  /**
   * Create new payment job and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)

    // Map payments to Payment
    if (typeof this.payments !== 'undefined') {
      this.payments = this.payments.map(payment => new Payment(payment))
    }

    // Map order to Order
    if (typeof this.order !== 'undefined') {
      this.order = new Order(this.order)
    }

    // Map invoices to Invoice
    if (typeof this.invoices !== 'undefined') {
      this.invoices = this.invoices.map(invoice => new Invoice(invoice))
    }

    // Map reversals to Reversal
    if (typeof this.reversals !== 'undefined') {
      this.reversals = this.reversals.map(reversal => new Reversal(reversal))
    }

    // Map split outpayment to SplitOutpayment
    if (typeof this.splitOutpayment !== 'undefined') {
      this.splitOutpayment = new SplitOutpayment(this.splitOutpayment)
    }
  }

  /**
   * @return {Date}
   */
  get createDateTimeUtc () {
    return this._createDateTimeUtc
  }

  /**
   * @param {string} value
   */
  set createDateTimeUtc (value) {
    this._createDateTimeUtc = new Date(value)
  }

  /**
   * @return {Date}
   */
  get expirationDateTimeUtc () {
    return this._expirationDateTimeUtc
  }

  /**
   * @param {string} value
   */
  set expirationDateTimeUtc (value) {
    this._expirationDateTimeUtc = new Date(value)
  }

  /**
   * @param {string} value
   */
  set paidDateTimeUtc (value) {
    this._paidDateTimeUtc = new Date(value)
  }

  /**
   * @return {Date}
   */
  get paidDateTimeUtc () {
    return this._paidDateTimeUtc
  }

  /**
   * @return {string|null}
   */
  get orderNumber () {
    if (!this.order) {
      return null
    }

    return this.order.orderNumber
  }

  /**
   * @return {Object|null}
   */
  get billingAddress () {
    if (!this.order || !this.order.billingAddress) {
      return null
    }

    return this.order.billingAddress
  }

  /**
   * @return {string|null}
   */
  get customer () {
    if (!this.billingAddress) {
      return null
    }

    return [this.billingAddress.firstName, this.billingAddress.middleName, this.billingAddress.lastName].filter(Boolean).join(' ')
  }

  /**
   * @return {string|null}
   */
  get phoneNumber () {
    if (!this.billingAddress) {
      return null
    }

    return this.order.billingAddress.phoneNumber1
  }

  /**
   * @return {Object|null}
   */
  get shippingAddress () {
    if (!this.order || !this.order.shippingAddress) {
      return null
    }

    return this.order.shippingAddress
  }

  /**
   * @return {string|null}
   */
  get emailAddress () {
    if (!this.order || !this.order.billingIdentity) {
      return null
    }

    return this.order.billingIdentity.emailAddress
  }
}
